import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

export class ProductVariantsFormController extends Controller {
  static targets = [
    'field',
  ];
  static values = {
    url: String,
  };

  async update() {
    const variantUrl = new URL(this.urlValue, window.location.origin);

    for (const [ key, value ] of new URL(window.location).searchParams.entries()) {
      variantUrl.searchParams.append(key, value);
    }

    await get(variantUrl, { responseKind: 'turbo-stream' });
  }
}
